import React from 'react';
import {
  Modal,
  Button,
  Image,
} from 'react-bootstrap';

import {
  FaPalette,
  FaShieldAlt,
  FaLayerGroup,
  FaFlag,
  FaHistory,
  FaCode,
} from 'react-icons/fa';

import 'bootstrap/dist/css/bootstrap.min.css';

const SupportWebsiteModal = ({ show, onClose }) => {
  const handlePatreonClick = () => {
    window.open(
      'https://www.patreon.com/hearthcards',
      '_blank',
      'noopener,noreferrer'
    );
  };

  const handleKofiClick = () => {
    window.open(
      'https://ko-fi.com/hearthcards',
      '_blank',
      'noopener,noreferrer'
    );
  };

  const supporterBenefits = [
    {
      id: 'identity',
      title: 'Custom Name & Icon',
      description:
        'Customize your HearthCards username with colors, gradients, animations, and a supporter icon.',
      icon: FaPalette,
      showNamePreview: false,
    },
    {
      id: 'deletion',
      title: 'Card Deletion Protection',
      description:
        'Keep your creations protected from automatic card deletion.',
      icon: FaShieldAlt,
    },
    {
      id: 'sets',
      title: 'Extra Set Slots',
      description:
        'Get additional slots for creating your custom sets (and ability to use custom URLs. - coming soon)',
      icon: FaLayerGroup,
    },
    {
      id: 'banners',
      title: 'Extra QOL Tools',
      description:
        'Create custom banners and shareable card images with easy-to-use editors.',
      icon: FaFlag,
    },
    {
      id: 'history',
      title: 'Edit History - coming soon',
      description:
        'View and manage the edit history of your cards.',
      icon: FaHistory,
    },
    {
      id: 'api',
      title: 'HearthCards API Access - coming soon',
      description:
        'Access the HearthCards API for your own projects, tools, and integrations.',
      icon: FaCode,
    },
    {
      id: 'name-change',
      title: 'Name Change',
      description:
        'Change your HearthCards username every month.',
      icon: FaHistory,
    }
  ];

  return (
    <>
      <style>
        {`
          .support-modal .modal-dialog {
            max-width: 820px;
          }

          .support-modal .modal-content {
            border-radius: 16px;
          }

          .support-modal-intro {
            display: flex;
            align-items: center;
            gap: 1rem;
            margin-bottom: 1.5rem;
          }

          .support-modal-profile {
            flex: 0 0 auto;
            width: 76px;
            height: 76px;
            object-fit: cover;
          }

          .support-modal-intro p {
            margin: 0;
            color: #888;
            font-size: 0.9rem;
            line-height: 1.5;
          }

          .support-benefit-card {
            display: flex;
            height: 100%;
            align-items: flex-start;
            gap: 0.9rem;
            padding: 1rem;
            border: 1px solid rgba(128, 128, 128, 0.22);
            border-radius: 14px;
            background: rgba(128, 128, 128, 0.06);
          }

          .support-benefit-visual {
            flex: 0 0 46px;
            display: flex;
            width: 46px;
            height: 46px;
            align-items: center;
            justify-content: center;
            border-radius: 10px;
            background: rgba(128, 128, 128, 0.08);
            color: #818ebd;
            font-size: 1.25rem;
          }

          .support-benefit-info {
            min-width: 0;
            flex: 1;
          }

          .support-benefit-title {
            margin: 0 0 0.25rem;
            font-size: 0.95rem;
            font-weight: 700;
          }

          .support-benefit-description {
            margin: 0;
            color: #888;
            font-size: 0.8rem;
            line-height: 1.4;
          }

          .support-name-preview {
            display: inline-flex;
            align-items: center;
            gap: 0.4rem;
            margin-top: 0.65rem;
            padding: 0.35rem 0.55rem;
            border: 1px solid rgba(128, 128, 128, 0.18);
            border-radius: 8px;
            background: rgba(128, 128, 128, 0.07);
          }

          .support-name-icon {
            width: 24px;
            height: 24px;
            object-fit: contain;
          }

          .support-name-text {
            display: inline-block;
            color: transparent;
            font-size: 0.9rem;
            font-weight: 700;

            background-image: linear-gradient(
              120deg,
              #2f8fd5,
              #3fbf8f,
              #81368f,
              #2f8fd5
            );

            background-size: 300% 300%;
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;

            animation:
              supporter-preview-gradient
              5.5s
              ease-in-out
              infinite;
          }

          @keyframes supporter-preview-gradient {
            0% {
              background-position: 0% 50%;
            }

            50% {
              background-position: 100% 50%;
            }

            100% {
              background-position: 0% 50%;
            }
          }

          .support-modal-actions {
            display: flex;
            justify-content: center;
            gap: 0.6rem;
            margin-top: 1.5rem;
          }

          @media (max-width: 767px) {
            .support-modal .modal-dialog {
              max-width: none;
            }

            .support-modal-intro {
              align-items: flex-start;
            }

            .support-modal-profile {
              width: 60px;
              height: 60px;
            }

            .support-modal-actions {
              flex-direction: column;
            }
          }

          @media (prefers-reduced-motion: reduce) {
            .support-name-text {
              animation: none;
              background-position: 50% 50%;
            }
          }
        `}
      </style>

      <Modal
        show={show}
        onHide={onClose}
        centered
        className="support-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Support HearthCards
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="p-4">
          <div className="support-modal-intro">
            <Image
              src="/images/users/pictures/66c760d0763594.21099192.jpg"
              roundedCircle
              className="support-modal-profile"
              alt="Nikko's profile picture"
            />

            <p className="mb-0">
              Hi! I'm Nikko, the sole creator and maintainer
              of HearthCards for the past 12 years. Running
              and updating the website costs not only my time
              but also money. HearthCards doesn't feature ads,
              and I make virtually nothing from it, as
              pretty much all money donated is dedicated to
              covering the site's running costs. If you'd like
              to help with that and want the development of
              HearthCards to continue, there are two options.
            </p>
          </div>

          <div className="support-modal-actions mb-4">
            <Button
              variant="primary"
              onClick={handlePatreonClick}
            >
              Become a Patreon Supporter
            </Button>

            <Button
              variant="outline-secondary"
              onClick={handleKofiClick}
            >
              One-Time Donation on Ko-Fi
            </Button>
          </div>

          <div className="mb-3">
            <h5 className="mb-1">
              Patreon Supporter Benefits
            </h5>
          </div>

          <div className="row g-3">
            {supporterBenefits.map((benefit) => {
              const Icon = benefit.icon;

              return (
                <div
                  key={benefit.id}
                  className="col-12 col-md-6"
                >
                  <div className="support-benefit-card">
                    <div
                      className="support-benefit-visual"
                      aria-hidden="true"
                    >
                      <Icon />
                    </div>

                    <div className="support-benefit-info">
                      <h6 className="support-benefit-title">
                        {benefit.title}
                      </h6>

                      <p className="support-benefit-description">
                        {benefit.description}
                      </p>

                      {benefit.showNamePreview && (
                        <div className="support-name-preview">
                          <img
                            src="/images/emotes/legendary.png"
                            srcSet={[
                              '/images/emotes/legendary.png 1x',
                              '/images/emotes/legendary2.png 2x',
                              '/images/emotes/legendary3.png 4x',
                            ].join(', ')}
                            alt=""
                            className="support-name-icon"
                          />

                          <span className="support-name-text">
                            YourName
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <p className="small text-muted text-center mt-3 mb-0">
            Every contribution helps keep HearthCards
            online and improving. Thank you for considering!
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={onClose}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SupportWebsiteModal;